import { Form, field } from "lib/form";

export default class RfeUploadForm extends Form {
  @field("File") public file: File;

  @field("Base") public base: string;

  @field("Case Name") public caseName: string;
}
